// extracted by mini-css-extract-plugin
module.exports = {"heading":"OrganizationTable_heading__3Ubr7","dropdown":"OrganizationTable_dropdown__rWXs7","locations":"OrganizationTable_locations__3Nkh6"};